import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ReservationsVehicleStayList } from 'src/features/reservations/types/reservationType';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const BASE_URL = 'reservations/:parkingId/vehicle-stay-reservation/';

interface DTO extends ListDTO {
    parkingId: string;
    reservationType?: string;
    status?: string;
    vehicle_stay_reservation_type?: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({
    parkingId,
    reservationType,
    status,
    vehicle_stay_reservation_type,
    ...params
}: DTO): Promise<ListResponseSmartParkAPI<ReservationsVehicleStayList>> => {
    const RESOURCE = new URL(formatResourcePath(BASE_URL, { parkingId }), window.location.origin);

    if (reservationType) {
        RESOURCE.searchParams.set('reservation_type', reservationType);
    }
    if (status) {
        RESOURCE.searchParams.set('status', status);
    }
    if (vehicle_stay_reservation_type) {
        RESOURCE.searchParams.set('vehicle_stay_reservation_type', vehicle_stay_reservation_type);
    }

    const RESOURCE_URL = RESOURCE.search
        ? formatResourcePath(BASE_URL, { parkingId }).concat(RESOURCE.search)
        : formatResourcePath(BASE_URL, { parkingId });

    return axios.get(RESOURCE_URL, { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    const { parkingId } = payload;

    return useQuery({
        queryKey: [BASE_URL, payload],
        queryFn: async () => await queryFn(payload),
        enabled: !!parkingId,
        ...config,
    });
};

export { useQueryHook as useReservationsVehicleStayList };
